import React, { useRef, useState, useLayoutEffect, useEffect } from 'react';
import TopBar from './components/TopBar/TopBar';
import HeaderBar from './components/HeaderBar/HeaderBar';
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs';
import styles from './AppHeader.module.css';

export default function AppHeader(props) {
  const headerRef = useRef(null);
  const [headerH, setHeaderH] = useState(0);

  useLayoutEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const update = () => setHeaderH(el.getBoundingClientRect().height);
    const ro = new ResizeObserver(update);
    ro.observe(el);
    update();
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--app-header-height',
      `${headerH}px`
    );
  }, [headerH]);

  return (
    <>
      <header ref={headerRef} className={styles.root} id='header'>
        <TopBar />

        <HeaderBar {...props} />

        <div className={styles.divider}>
          <div className={styles.dividerInner} />
        </div>

        <Breadcrumbs items={props.breadcrumbs || []} />
      </header>

      <div style={{ height: headerH }} aria-hidden='true' />
    </>
  );
}
